// Install Material-UI in your project if not already installed
// npm install @mui/material @emotion/react @emotion/styled

import React, { useState } from 'react';
import { Button, FormControl, InputLabel, Input, Snackbar, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    feedback: '',
  });

  const [isSnackbarOpen, setSnackbarOpen] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can add logic here to handle form submission
    // For now, let's just show a Snackbar
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <FormContainer>
      <Typography variant="h4" sx={{fontFamily:'Cinzel Decorative'}} gutterBottom>
        Feedback Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="name">Name</InputLabel>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="email">Email</InputLabel>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="normal">
          <TextField
            id="feedback"
            name="feedback"
            label="Feedback"
            multiline
            rows={4}
            value={formData.feedback}
            onChange={handleInputChange}
            required
          />
        </FormControl>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </form>
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Feedback submitted successfully!"
      />
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  backgroundColor: 'aliceblue',
  color: 'gold',
  borderRadius: '8px',
  border: '2px solid darkslategrey', // Add a border
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)', // Add a subtle box shadow
  maxWidth: '400px', // Set a maximum width
  margin: 'auto', // Center the form horizontally
  marginTop: '50px', // Add some top margin
});

export default FeedbackForm;
